<template>	
	<el-row   type="flex" justify="center">
		<el-col :xs="24" :sm="24" :md="24">
			<div class="lf_match_info_box">
				<div class="d_title">{{systemlang=='cn'?'报名查询':'Signup info'}} | <span>{{systemlang!='cn'?'报名查询':'Signup info'}}</span></div>
			</div>
			<el-row type="flex" v-if="showflag == 's'" justify="center">
				<el-col :xs="24" :sm="24" :md="24">
					<div class="lf_entry_info_box_left_con">
						<div class="lf_entry_info_box_left_con_list">
							<div class="lf_entry_info_box_left_con_list_left">
								{{langs.text_Playersname}}
							</div>
							<div class="lf_entry_info_box_left_con_list_right">
								<el-input v-model="searchParam.vipname" ></el-input>
							</div>
						</div>
						<div class="lf_entry_info_box_left_con_list">
							<div class="lf_entry_info_box_left_con_list_left">
								{{langs.text_IDtype}}
							</div>
							<div class="lf_entry_info_box_left_con_list_right">
								<el-select  v-model="searchParam.nvipidtype" size="default" class="m-2">
										<el-option v-for="item in nvipidtypeArr"
													:key="item.key"
													:label="item.value"
													:value="item.key" />
									</el-select>
							</div>
						</div>
						<div class="lf_entry_info_box_left_con_list">
							<div class="lf_entry_info_box_left_con_list_left">
								{{langs.text_IDnumber}}
							</div>
							<div class="lf_entry_info_box_left_con_list_right">
								<el-input v-model="searchParam.nvipidnumber" ></el-input>
							</div>
						</div>
						<div class="lf_entry_info_box_left_con_list" style="display: flex;justify-content: center;margin-top: 1rem;">
							<el-button @click="goshearch" type="danger" >{{langs.text_Submit}}</el-button>
							
						</div>
					</div>
				</el-col>
			</el-row>
			
			<div  v-if="showflag == 'r'" class="lf_course_name_data_box">
				<div class="lf_course_name_data_tit">
					<div class="lf_1">{{langs.Order}}</div>
					<div class="lf_2">{{langs.OrderNumber}}</div>
					<div class="lf_3">{{langs.EventName}}</div>
					<div class="lf_4">{{langs.AmountYuan}}</div>
					<div class="lf_5">{{langs.StatusofOrder}}</div>
					<div class="lf_6">{{langs.EventPeriod}}</div>
					<div class="lf_7">{{langs.DeadlinePaymentDate}}</div>
					<div class="lf_8">{{langs.OrderTime}}</div>
					<div class="lf_9">{{langs.Operation}}</div>
				</div>
				<template v-for="(b,index) in list">
				<div class="lf_course_name_data_con" :id="b.v_oid">
					<div class="lf_1">{{page.start+index+1}}</div>
					<div class="lf_2" @click="showD(index)">{{b.v_oid}}</div>
					<div class="lf_3">{{b.v_matchname}}</div>
					<div class="lf_4">{{b.v_amount}}</div>
					<div class="lf_5">{{orderStatusTitle(b)}}</div>
					<div class="lf_6">{{b.ColumnStart}}</div>
					<div class="lf_7">{{b.Registpayment}}</div>
					<div class="lf_8">{{b.v_orderdate}}</div>
					<div class="lf_9"><text @click="lookorder(b.v_oid)">{{langs.look}}</text><text  v-if="(b.v_pstatus =='0' || b.v_pstatus == '2') && b.o_sts != 'wsh' && b.o_sts != 'jj' && b.o_sts != 'qx'" @click="qxdd(b.v_oid)">{{langs.oCancel}}
					</text> 
						 <text @click="payOrder(b.v_oid,index,b.v_id)" v-if="b.o_sts == 'wplay'">{{langs.WaitingforPaymentN}}</text>
						</div>
				</div>
				
				</template>
			</div>

			<div>
				<Entrynovipinfo v-if="showflag == 'i'" @backlist="backlist" :orderid="orderid"></Entrynovipinfo>
			</div>
			
			<!-- 仅手机上点比赛名显示 弹窗 -->
			<div class="lf_course_name_data_box_phone_box" id="pdf" v-if="showDvs">
				<div class="lf_course_name_data_box_phone">
					<img class="lf_close_img" src="../../assets/images/close.png" @click="close()" alt="">
					<div class="lf_course_name_data_tit_phone">
						<div class="lf_1">{{langs.Order}}</div>
						<div class="lf_2">{{langs.OrderNumber}}</div>
						<div class="lf_3">{{langs.EventName}}</div>
						<div class="lf_4">{{langs.AmountYuan}}</div>
						<div class="lf_5">{{langs.StatusofOrder}}</div>
						<div class="lf_6">{{langs.EventPeriod}}</div>
						<div class="lf_7">{{langs.DeadlinePaymentDate}}</div>
						<div class="lf_8">{{langs.OrderTime}}</div>
						<div class="lf_9">{{langs.Operation}}</div>
					</div>
					<div class="lf_course_name_data_con_phone">
						<div class="lf_1">{{page.start+showDv+1}}</div>
						<div class="lf_2" >{{list[showDv].v_oid}}</div>
						<div class="lf_3">{{list[showDv].v_matchname}}</div>
						<div class="lf_4">{{list[showDv].v_amount}}</div>
						<div class="lf_5">{{orderStatusTitle(list[showDv])}}</div>
						<div class="lf_6">{{list[showDv].ColumnStart}}</div>
						<div class="lf_7">{{list[showDv].Registpayment}}</div>
						<div class="lf_8">{{list[showDv].v_orderdate}}</div>
						<div class="lf_9"><text @click="Douwn">{{langs.PrintOrder}}</text> 
							<text @click="payOrder(list[showDv].v_oid,false,list[showDv].v_id)" v-if="list[showDv].o_sts == 'wplay'">{{langs.WaitingforPaymentN}}</text>
						</div>
					
					</div>
				</div>	
			</div>



			<div class="lf_course_name_data_box_phone_box"  v-if="paybox">
				
				<div class="lf_course_name_data_box_pay">
					<img class="lf_close_img" src="../../assets/images/close.png" @click="closepayb" alt="" />
					<div class="lf_course_name_data_box_pay_t">{{list[showDv].v_matchname}}</div>
					<div v-if="!paysucess" class="lf_course_name_data_box_pay_M">{{list[showDv].PlayRegClassType}} <text>{{list[showDv].v_amount}}元</text></div>
					<div v-if="paysucess" class="lf_course_name_data_box_pay_M"><text>{{langs.PaidSuccessfully}}</text></div>
					<div v-if="!paysucess" class="lf_course_name_data_box_pay_b">
						<img src="../../assets/images/payz.png" @click="alipay" alt="">
						<img src="../../assets/images/payw.png"  @click="weixinpay" alt="">
						
					</div>
					<text v-if="wximg != '' && !paysucess" style="display:block;">请用微信扫码支付</text>
					<div v-if="wximg != '' && !paysucess" class="lf_course_name_data_box_pay_b1"><img :src="wximg"/></div>
				</div>	
			</div>

			<div class="lf_course_name_data_box_phone_box"  v-if="cardpaybox">
				
				<div class="lf_course_name_data_box_pay">
					<img class="lf_close_img" src="../../assets/images/close.png" @click="closepayb" alt="" />
					<div class="lf_course_name_data_box_pay_t">{{list[showDv].v_matchname}}</div>
					<div v-if="!paysucess" class="lf_course_name_data_box_pay_M">{{list[showDv].PlayRegClassType}} <text>{{list[showDv].v_amount}}元</text></div>
					<div v-if="paysucess" class="lf_course_name_data_box_pay_M"><text>{{langs.PaidSuccessfully}}</text></div>
					<div v-if="!paysucess" class="lf_course_name_data_box_pay_b">
						{{ langs.cardpayTs }}
					</div>
					
				</div>	
			</div>
			
			<div v-if="aliclickshow" @click="aliclickshowhide" class="lf_course_name_data_box_phone_box" style="background-color: rgba(13,13,13,0.6);">
				<img style="width: 100%;position: absolute;top: 0;" src="../../assets/images/00222.png" alt="">
			</div>
			
		</el-col>
	</el-row>
	<form id="dataform" method="post" style="display:none;"></form>

</template>

<script>
import html2Canvas from '../../plugs/htmlToPDF';
import Entrynovipinfo from './Entrynovipinfo';
import axios from '../../axios/request';
import axiosx from '../../axios/postx';
 import {
        getSystemLang,
        getLangAll
    } from '../../lang';
    export default {
		data() {
		    return {
		        langs: '',
		        systemlang: 'cn',
				page:{
					limit:5,
					page:1,
					allpage:0,
					count:0,
					start:0
				},
				pagevalue:1,
				aliclickshow:false,
				bFlag:'all', // all:全部订单 wsh:等待审核 wplay:等待支付 ok:已完成
				list:[],
				showDv:0,
				showDvs:false,
				timeer:0,
				paybox:false,
				orderid:'',
				v_id:'',
				wximg:'',
				getorderid:'',
				paysucess:false,
				cardpaybox:false,
				showflag:'s',
				searchParam:{
					vipname:'',//球员姓名
					nvipidtype:'0', //身份类型
					nvipidnumber:'',//证件号
				},
				nvipidtypeArr:[
					{key:'0',value:'请选择证件类型'},
					{key:'二代身份证',value:'二代身份证'},
					{key:'港澳通行证',value:'港澳通行证'},
					{key:'台湾通行证',value:'台湾通行证'},
					{key:'护照',value:'护照'}
				],
				
		    }
		},
        name: 'Player',
        props: {
            msg: String,
			mt_id:String,
			order_id:String,
        },
		components: {
			Entrynovipinfo
        },
		created() {
			
			this.systemlang = getSystemLang();
			this.langs = getLangAll(this.systemlang);
			if(this.order_id)
			{
				this.getorderid = this.order_id;
			}
			this.getData();
			if(this.systemlang == 'en')
			{
				this.nvipidtypeArr = [
					{key:'0',value:'Please select a certificate type'},
					{key:'二代身份证',value:'Second generation ID card'},
					{key:'港澳通行证',value:'Hong Kong and Macao pass'},
					{key:'台湾通行证',value:'Taiwan Pass'},
					{key:'护照',value:'passport'}
				];
				
			}
		},
		watch:{
			bFlag(value)
			{
				this.bFlag = value;
				this.getData();
			}
			
		},
		methods:{
			aliclickshowhide(){
				this.aliclickshow = false;
			},
			closepayb(){
				this.paybox = false;
				this.cardpaybox = false;
				this.getData();
				clearInterval(this.timeer);
			},
			is_weixn(){  

				var ua = navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {

					return true;

				}

				return false;

			},
			Douwn(){
				if(this.is_weixn())
				{
					this.aliclickshow = true;
					return false;	
				}
				console.log(this.$refs.pdf);	
				html2Canvas('订单下载打印','pdf');
				alert('下载中.....');
				
				
			},
			close(){
				this.showDvs = false;
			},
			showD(index)
			{
				// if(document.documentElement.clientWidth > 960)
				// {
				// 	return false;
				// }
				this.showDv = index;
				this.showDvs = true;
			},
			qxdd(orderId){
				this.$confirm(this.langs.oCancel, this.langs.oCancel, {
				confirmButtonText: this.langs.Confirm,
				cancelButtonText: this.langs.Cancel,
				type: 'warning'
				}).then(() => {
					axiosx('user/notvipdel.json',{id:orderId})
					.then((res)=>{
						let data = res.data;
						if(data.msgCode!='200')
						{
							this.$message({
								type: 'error',
								message: data.msg
							});
						}
						else
						{
							this.$message({
								type: 'success',
								message: 'success!'
							});
							this.getorderid = '';
							this.getData();
						}
					});
				
				});
			},
			sqtk(orderId){
				this.$confirm(this.langs.RefundConfirm, this.langs.OperationConfirm, {
				confirmButtonText: this.langs.Confirm,
				cancelButtonText: this.langs.Cancel,
				type: 'warning'
				}).then(() => {
					axiosx('user/notvipordetrurn.json',{id:orderId})
					.then((res)=>{
						let data = res.data;
						if(data.msgCode!='200')
						{
							this.$message({
								type: 'error',
								message: data.msg
							});
						}
						else
						{
							this.$message({
								type: 'success',
								message: 'success!'
							});
							this.getData();
						}
					});
				
				});
			},
			changePage(value)
			{
				this.page.page = value;
				this.getData();
			},
			goFlag(str)
			{
				this.bFlag = str;
			},
			orderStatusTitle(row){
				if(!row) return '';
				let title = row.o_sts_d_title || '';
				if(title && String(title).indexOf('user:o_') !== 0){
					return title;
				}
				let key = row.o_sts_d || row.o_sts || '';
				let audit = parseInt(row.nvip_audit || 0);
				if(audit === 1 || key === 'wsh'){
					return this.langs.NvipAuditPending || this.langs.WaitingforApproval || '审核中';
				}
				if(audit === 2 && (key === 'wplay' || key === 'wplayno')){
					return this.langs.NvipAuditPass || '审核通过';
				}
				if(audit === 3 || key === 'jj'){
					return this.langs.NvipAuditReject || '已拒绝';
				}
				if(audit === 4 || key === 'qx'){
					return this.langs.NvipAuditCancel || '已取消';
				}
				if(key === 'wplay'){
					return this.langs.WaitingforPayment || '待支付';
				}
				return title || key;
			},
			getData(s){
				let  param = {};
				param.limit = this.page.limit;
				param.page = this.page.page;
				param.type = this.bFlag;
				param.mt_id = this.mt_id;
				param.order_id = this.getorderid;
				for(let i in this.searchParam)
				{
					param[i] = this.searchParam[i];
				}
				axios('user/notviporder.json',param)
				.then((res)=>{
					let data = res.data;
					if(data.msgCode!='200')
					{
						this.list = [];
						this.showflag = 's';
						if(s)
						{
							alert(data.msg);
						}
						
					}
					else
					{
						this.list = data.data;
						this.showflag = 'r';
					}
				});
			},
//<el-button type="primary" @click="weixinpay">微信</el-button>
// <el-button type="primary" @click="alipay">支付宝</el-button>
			weixinpay(){
				this.pay('wx',this.orderid);
				// this.paybox =false;
					
			},
			yhkpay(){
				this.pay('yhk',this.orderid);   
					this.paybox =false;
					this.cardpaybox = true;
			},
			alipay(){
				if(this.is_weixn())
				{
					this.aliclickshow = true;
					this.paybox =false;
				}
				else
				{
					this.pay('ali',this.orderid);   
					this.paybox =false;
				}
				
			},
			pay(type,orderid)
			{
				
				let param = {};
				param.type = type;
				param.id = orderid;
				if(type == 'wx')
				{
					// axios('user/notvippay.json',param)
					// .then((res)=>{
					// 	let data = res.data;
					// 	if(data.msgCode == '200')
					// 	{
					// 		this.wximg = data.msg;
					// 		// this.$alert('<img src="'+data.msg+'"></img>', '微信扫码付款', {
					// 		// dangerouslyUseHTMLString: true
					// 		// });
					// 		this.checkPay(orderid,'wxpay');
					// 	}
					// 	else
					// 	{
					// 		alert(data.msg);
					// 	}
						
					// });
					axios('user/notvippay.json',param)
					.then((res)=>{
						let data = res.data;
						
						if(data.msgCode == '200')
						{
							if(data.dev == 'mobile')
							{
								let cs = data.data;
								// window.open(data.sendurl);
								// window.location = data.sendurl; // 将当前页面重定向到 https://www.example.com
								var form1 = window.document.getElementById("dataform");//获取form1对象	
								// let form1 = window.document.createElement("form");
								form1.innerHTML  = '';
								form1.action = data.sendurl;
								form1.target="_blank";
								form1.setAttribute('referrerpolicy', 'origin');
								for(let i in cs)
								{
									let newElement = window.document.createElement("input");
									newElement.setAttribute("name",i);
									newElement.setAttribute("value",cs[i]);
									newElement.style.visibility="hidden";//设置为隐藏
									form1.appendChild(newElement);
								}
								form1.submit();
								this.checkPay(orderid,'wxpay');
							}
							else if(data.dev == 'pc')
							{
								this.wximg = data.msg;
								// this.$alert('<img src="'+data.msg+'"></img>', '微信扫码付款', {
								// dangerouslyUseHTMLString: true
								// });
								this.checkPay(orderid,'wxpay');
							}
							else if(data.dev == 'wx')
							{
								let cs = data.data;
								// window.open(data.sendurl);
								// window.location = data.sendurl; // 将当前页面重定向到 https://www.example.com
								var form1 = window.document.getElementById("dataform");//获取form1对象	
								// let form1 = window.document.createElement("form");
								form1.innerHTML  = '';
								form1.action = data.sendurl;
								// form1.target="_blank";
								for(let i in cs)
								{
									let newElement = window.document.createElement("input");
									newElement.setAttribute("name",i);
									newElement.setAttribute("value",cs[i]);
									newElement.style.visibility="hidden";//设置为隐藏
									form1.appendChild(newElement);
								}
								form1.submit();
								this.checkPay(orderid,'wxpay');
							}
							
						}
						
					});
				}
				else if(type == 'ali')
				{
					axios('user/notvippay.json',param)
					.then((res)=>{
						let data = res.data;
						if(data.msgCode == '200')
						{
							let cs = data.data;
							var form1 = window.document.getElementById("dataform");//获取form1对象	
							// let form1 = window.document.createElement("form");
							form1.innerHTML  = '';
							form1.action = data.sendurl;
							form1.target="_blank";
							for(let i in cs)
							{
								let newElement = window.document.createElement("input");
								newElement.setAttribute("name",i);
								newElement.setAttribute("value",cs[i]);
								newElement.style.visibility="hidden";//设置为隐藏
								form1.appendChild(newElement);
							}
							
							form1.submit();
							
							this.checkPay(orderid,'alipay');
						}
						else
						{
							alert(data.msg);
						}
						
					});
				}
				else if(type == 'yhk')
				{
					axios('user/notvippay.json',param)
					.then((res)=>{
						let data = res.data;
						if(data.msgCode == '200')
						{
							let cs = data.data;
							var form1 = window.document.getElementById("dataform");//获取form1对象	
							// let form1 = window.document.createElement("form");
							form1.innerHTML  = '';
							form1.action = data.sendurl;
							form1.target="_blank";
							for(let i in cs)
							{
								let newElement = window.document.createElement("input");
								newElement.setAttribute("name",i);
								newElement.setAttribute("value",cs[i]);
								newElement.style.visibility="hidden";//设置为隐藏
								form1.appendChild(newElement);
							}
							
							form1.submit();
							
							this.checkYhkPay(orderid,this.v_id);
						}
						else
						{
							alert(data.msg);
						}
						
					});
				}
				
			},
			checkYhkPay(id,v_id){
				clearInterval(this.timeer);
				this.timeer = setInterval(()=>{
					axiosx('user/yizhifu.json',{id:v_id})
					.then((res)=>{
						let data = res.data;
						if(data.msgCode=='200')
						{
							
							this.paysucess = true;
							this.getData();
							clearInterval(this.timeer);
							setTimeout(()=>{
								this.paysucess = false;
								this.paybox =false;
								this.cardpaybox = false;
							},2000);
						}	
					});

				},3000);
				
			},
			checkPay(id,payway){
				clearInterval(this.timeer);
				this.timeer = setInterval(()=>{
					axiosx('user/checkpay.json',{id:id,payway:payway})
					.then((res)=>{
						let data = res.data;
						if(data.msgCode=='200')
						{
							
							this.paysucess = true;
							this.getData();
							clearInterval(this.timeer);
							setTimeout(()=>{
								this.paysucess = false;
								this.paybox =false;
							},2000);
						}	
					});

				},3000);
				
			},
			payOrder(orderid,check,v_id)
			{
				if(check)
				{
					this.showDv = check;
				}
				this.v_id = v_id;
				this.orderid = orderid;
				this.paybox = true;
				console.log('ssss');
				return false;
				
			},
			goshearch(){
				this.getorderid = '';
				if(this.searchParam.nvipidtype == '0')
				{
					alert(this.langs.text_IDtype_select);
					return false;
				}
				this.getData(true);
			},
			lookorder(orderid)
			{
				console.log(orderid);
				this.orderid = orderid;
				this.showflag = 'i';
			},
			backlist()
			{
				console.log('backlist');
				this.showflag = 'r';
			}
		}
    }
</script>

<style scoped="scoped">
	.d_title {
		margin-top: 0.14rem;
		color: rgb(192, 21, 62);
		font-size: 0.28rem;
		padding-bottom: 4px;
		/* font-weight: bold; */
		font-family: '微软雅黑';
		border-bottom: 1px solid rgb(192, 21, 62);
		display: inline-block;
		padding-right: 30px;
	}

	.d_title span {
		font-size: 0.24rem;
	}
	.lf_match_info_box{
		padding: 0.35rem 0px;
		font-size: 0.24rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.lf_match_info_box_r{
		display: flex;
		justify-content: flex-end;
	}
	.lf_course_bogo{
		position: relative;
		font-size: 0.2rem;
		color: #fff;
	}
	.lf_course_bogo_des{
		height: 0.6rem;
		display: flex;
		align-items: center;
		text-indent: 0.2rem;
		position: absolute;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.498);
		width: 100%;
	}
	.lf_course_name_data_box{
		background-color: #FAFAFA;
	}
	.lf_hide_select{
		display: none!important;
	}
	.lf_course_name_data_tit{
		width: 96%;
		border-bottom: 1px solid #efefef;
		color: #333;
		font-size: 0.24rem;
		height: 0.7rem;
		display: flex;
		align-items: center;
		margin: 0 auto;
	}
	.lf_course_name_data_con{
		width: 96%;
		color: #999;
		font-size: 0.24rem;
		height: 0.7rem;
		display: flex;
		align-items: center;
		margin: 0 auto;
	}
	.lf_course_name_data_tit div,.lf_course_name_data_con div{
		width: 12%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		flex-direction: column;
	}
	.lf_1,.lf_4,.lf_5{
		width: 7%!important;
	}
	.lf_course_name_data_tit .lf_9{
		flex-grow: 1;
		display: flex;
		align-items: center;
		flex-direction: row!important;
	}
	.lf_course_name_data_con .lf_9{
		flex-grow: 1;
		display: flex;
		align-items: center;
		flex-direction: row!important;
	}
	.lf_9 text{cursor: pointer;
		color: #C0153E;
		margin-right: 0.1rem;
	}
	.lf_course_name_data_con .lf_2{
		justify-content: flex-start;
	}
	.lf_tab_tit_box {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-bottom: 0.2rem;
	}
	.lf_tab_little_box{
		height: 30px;
		display: flex;
		align-items: center;
	}
	.lf_tab_little_box div {
		padding: 0 0.16rem;
		height: 0.14rem;
		font-size: 0.24rem;
		color: #999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		border-right: 1px solid #999;
		word-break: keep-all;
		cursor: pointer;
	}
	.lf_tab_little_box div:nth-last-of-type(1){
		border-right: unset;
	}
	.lf_tab_little_box .lf_tab_box_select {
		color: #C0153E;
	}
	.el-pagination{
		justify-content: center;
	}
	.block{
		margin: 0.2rem auto;
	}
	
	
	.lf_course_name_data_box_phone{
		display: flex;
		align-items: center;
		position: fixed;
		background-color: #fff;
		width: 7rem;
		border-radius: 0.1rem;
		padding: 0.2rem 0.3rem;
	}
	.lf_course_name_data_box_phone .lf_course_name_data_tit_phone{
		width: 30%;
	}
	.lf_course_name_data_box_phone .lf_course_name_data_tit_phone,.lf_course_name_data_box_phone .lf_course_name_data_con_phone{
		flex-direction: column;
		padding: 0.5rem 0;
	}
	.lf_course_name_data_box_phone .lf_course_name_data_tit_phone div,.lf_course_name_data_box_phone .lf_course_name_data_con_phone div{
		flex-direction: row;
		width: 100%!important;
		min-height: 0.6rem;
		padding: 0.1rem 0;
	}
	.lf_course_name_data_box_phone_box{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 99;
		background-color: rgba(0,0,0,0.3);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.lf_close_img{
		width: 0.36rem;
		height: 0.36rem;
		position: absolute;
		right: 0.1rem;
		top: 0.1rem;
	}
	.lf_course_name_data_box_pay{
		display: flex;
		align-items: center;
		position: fixed;
		background-color: #fff;
		width: 5rem;
		border-radius: 0.1rem;
		padding: 0.5rem 0.3rem;
		flex-direction: column;
	}
	.lf_course_name_data_box_pay_t{
		font-size: 0.24rem;
		color: #333;
		margin: 0.2rem 0 0.1rem;
	}
	.lf_course_name_data_box_pay_M{
		font-size: 0.24rem;
		color: #333;
	}
	.lf_course_name_data_box_pay_M text{
		font-size: 0.24rem;
		color: #C0153E;
		margin-left: 0.1rem;
	}
	.lf_course_name_data_box_pay_b{
		display: flex;
		align-items: center;
		margin: 0.2rem 0;
		justify-content: space-between;
	}
	.lf_course_name_data_box_pay_b img{
		height: 0.7rem;
		width: auto;
	}
	.lf_course_name_data_box_pay_b1{
		display: flex;
		align-items: center;
		margin: 0.2rem 0;
		justify-content: center;
	}
	.lf_course_name_data_box_pay_b1 img{
		height: 3rem;
	}
	
	
	
	.lf_entry_info_box_left_con_list{
		display: flex;
		align-items: center;
		min-height: 0.8rem;
		justify-content: center;
	}
	.lf_entry_info_box_left_con_list_left{
		width: 2.5rem;
		display: flex;
		justify-content: flex-end;
		font-size: 0.24rem;
		color: #999;
		flex-shrink: 0;
	}
	.lf_entry_info_box_left_con_list_left text{
		color: #C0153E;
		display: flex;
		align-items: center;
	}
	.lf_entry_info_box_left_con_list_right{
		display: flex;
		align-items: center;
		margin-left: 0.8rem;
		font-size: 0.24rem;
	}
	.lf_entry_info_box_left_con_list_right .el-select{
		width: 7.8rem;
		height: 0.6rem;
	}
	.lf_entry_info_box_left_con_list_right .el-input{
		width: 7.8rem;
		height: 0.6rem;
		background: inherit;
		background-color: rgba(239, 239, 239, 1);
		border: none;
		border-radius: 2px;
		-moz-box-shadow: none;
		-webkit-box-shadow: none;
		box-shadow: none;
		font-family: '微软雅黑';
		font-weight: 400;
		font-style: normal;
		font-size: 0.16rem;
		text-align: left;
	}
	.lf_entry_info_box_left_con{
		background-color: rgba(250, 250, 250, 1);
		border: none;
		border-radius: 2px;
		padding: 1rem 0;
	}
	
	
	@media screen and (max-width: 768px) {
		.lf_match_info_box{
			padding: 0.35rem 0.2rem;
			margin-left: 0;
		}
		.lf_course_name_data_tit div:nth-of-type(n+3),.lf_course_name_data_con div:nth-of-type(n+3){
			display: none!important;
		}
		.lf_course_name_data_tit div.lf_9,.lf_course_name_data_con div.lf_9{
			display: flex!important;
		}
		.lf_course_name_data_tit div,.lf_course_name_data_con div{
			width: 45%!important;
		}
		.lf_course_name_data_tit .lf_1,.lf_course_name_data_con .lf_1{
			width: 10%!important;
		}
		.lf_hide_select{
			display: unset!important;
		}
		.lf_tab_little_box div {
			padding: 0 0.1rem;
			height: 0.14rem;
			font-size: 0.16rem;
			color: #999;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			border-right: 1px solid #999;
			word-break: keep-all;
		}
		.lf_course_name_data_box_phone{
			display: flex;
			align-items: center;
			position: fixed;
			background-color: #fff;
			width: 7rem;
			border-radius: 0.1rem;
			padding: 0.2rem 0.3rem;
		}
		.lf_course_name_data_box_phone .lf_course_name_data_tit_phone{
			width: 30%;
		}
		.lf_course_name_data_box_phone .lf_course_name_data_tit_phone,.lf_course_name_data_box_phone .lf_course_name_data_con_phone{
			flex-direction: column;
			padding: 0.5rem 0;
		}
		.lf_course_name_data_box_phone .lf_course_name_data_tit_phone div,.lf_course_name_data_box_phone .lf_course_name_data_con_phone div{
			flex-direction: row;
			width: 100%!important;
			min-height: 0.6rem;
			padding: 0.1rem 0;
		}
		.lf_course_name_data_box_phone_box{
			position: fixed;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			z-index: 99;
			background-color: rgba(0,0,0,0.3);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.lf_close_img{
			width: 0.36rem;
			height: 0.36rem;
			position: absolute;
			right: 0.1rem;
			top: 0.1rem;
		}
		.lf_entry_info_box_left_con_list_right .el-select{
			width: 4rem;
			margin-left: 0;
		}
		.lf_entry_info_box_left_con_list_right .el-input{
			width: 4rem;
			height: 30px;
			font-size: 0.26rem;
		}
		.lf_entry_info_box_left_con_list_right{
			margin-left: 0.1rem;
			height: 0.8rem;
			font-size: 0.26rem;
		}
		.lf_entry_info_box_left_con_list_left{
			width: 2rem;
			font-size: 0.26rem;
		}
	}
</style>
